import { generateBlockHash, generateBlockId } from '@/utils/canvas-block-layouts/common'
import { centerImageTransform } from '@/utils/canvas-block-layouts/ImageLayout'

export const REFERRAL_SLIDE_ELEMENT_FLAG = 'BOO-912-audience-referral'

export const REFERRAL_QR_STATES = Object.freeze({
  HIDDEN: 'hidden',
  READY: 'ready',
  NOT_ENROLLED: 'not-enrolled',
})

export const REFERRAL_QR_IMAGE = Object.freeze({
  WIDTH: 820,
  HEIGHT: 1000,
  PADDING: 50,
  LABEL: 'Get AhaSlides for free',
})

export const REFERRAL_QR_BLOCK_WIDTH = 300
export const REFERRAL_QR_BLOCK_MIN_WIDTH = 160

const REFERRAL_SIGNUP_PATH = '/pages/register'

const REFERRAL_TRACKING_PARAMS = Object.freeze({
  utm_medium: 'audience_referral',
  utm_content: 'deck_element',
})

export const isDeckOwner = ({ presentation, currentUser }) => {
  if (!presentation || !currentUser || presentation.userId == null) return false
  return String(presentation.userId) === String(currentUser.id)
}

/**
 * The deck owner's Reditus slug. Only the owner's own profile carries one, so a
 * collaborator editing someone else's deck gets null.
 */
export const resolveDeckOwnerReditusSlug = ({ presentation, currentUser }) => {
  if (!isDeckOwner({ presentation, currentUser })) return null
  return currentUser.reditusSlug || null
}

/** The sign-up URL the QR code encodes; `refby` is what attributes the sign-up to the presenter. */
export const buildReferralSignupUrl = ({ presenterDomain, slug, presentationId }) => {
  if (!presenterDomain || !slug) return ''
  const url = new URL(`${presenterDomain.replace(/\/+$/, '')}${REFERRAL_SIGNUP_PATH}`)
  url.searchParams.set('refby', slug)
  if (presentationId != null) url.searchParams.set('utm_source', `presentation_${presentationId}`)
  Object.entries(REFERRAL_TRACKING_PARAMS).forEach(([name, value]) => url.searchParams.set(name, value))
  return url.toString()
}

/** HIDDEN for anyone but the deck owner, NOT_ENROLLED when the owner has no referral slug yet. */
export const resolveReferralQrState = ({ isFlagEnabled, presentation, currentUser }) => {
  if (!isFlagEnabled || !isDeckOwner({ presentation, currentUser })) return REFERRAL_QR_STATES.HIDDEN
  return resolveDeckOwnerReditusSlug({ presentation, currentUser })
    ? REFERRAL_QR_STATES.READY
    : REFERRAL_QR_STATES.NOT_ENROLLED
}

export const buildReferralQrBlock = ({ slideId, imageUrl }) => {
  const width = REFERRAL_QR_BLOCK_WIDTH
  const height = Math.round(width * (REFERRAL_QR_IMAGE.HEIGHT / REFERRAL_QR_IMAGE.WIDTH))
  return {
    id: generateBlockId(slideId),
    type: 'Image',
    tag: 'image',
    content: { src: imageUrl, isReferralQr: true },
    style: {
      width: `${width}px`,
      height: `${height}px`,
      transform: centerImageTransform(width, height),
    },
    h: generateBlockHash(),
  }
}

export const isReferralQrBlock = (block) => Boolean(block && block.content && block.content.isReferralQr)

export const referralQrMinSize = () => [
  REFERRAL_QR_BLOCK_MIN_WIDTH,
  Math.round(REFERRAL_QR_BLOCK_MIN_WIDTH * (REFERRAL_QR_IMAGE.HEIGHT / REFERRAL_QR_IMAGE.WIDTH)),
]
